import { FormModel } from 'main/common/form-state-manager/FormModel'
import { IsNotEmpty } from 'main/common/validation/decorators/IsNotEmpty'

export class DomainFormValidator extends FormModel {

    @IsNotEmpty()
    name: string

    constructor(initialData?: any) {
        super(initialData)
        Object.assign(this, initialData)
    }

}
